import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import ReactDatatable from '@ashvin27/react-datatable';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getAdCounterListAction } from '../Action/action'
import Cookies from 'js-cookie';
const loginData = (!Cookies.get('loginSuccessBondiAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessBondiAdmin'));

const AdCounterList = () => {
	const [rows, setRows]	= useState([]);
	
	useEffect(() => {
		if (!loginData?.email) {
			window.location.href = `${config.baseUrl}login`
		}
		fetchList();
	}, [])
	
	const fetchList = async () => {
		let res = await getAdCounterListAction();
		if (res.success) {
			setRows(res.data || []);
		} else {
			setRows([]);
		}
	}
	
	const typeLabel = (t) => {
		if (Number(t) === 2) return 'Horizontal Banner';
		return 'Sidebar/Right Banner';
	};
	
	const columns = [
		{
			key: "Sno.",
			text: "#",
			cell: (row, index) => index + 1,
		},
		{
			key: "AdId",
			text: "Ad ID",
			cell: (item) => {
				const editPath = Number(item.type) === 2 ? `${config.baseUrl}edit-horizontal-baner/${item.AdId}` : `${config.baseUrl}edit-banner/${item.AdId}`;
				return (
					<>
						<Link to={editPath}>{item.AdId}</Link>
					</>
				)
			}
		},
		{
			key: "type",
			text: "Type",
			cell: (item) => typeLabel(item.type)
		},
		{
			key: "metrocity",
			text: "Metrocity"
		},
		{
			key: "IpAddress",
			text: "IP Address"
		},
		{
			key: "CreatedOn",
			text: "Created On",
			cell: (item) => item.CreatedOn ? moment(item.CreatedOn).format('DD/MM/YYYY HH:mm') : ''
		}
	];

	const configForTable = {
		page_size: 10,
		length_menu: [10, 20, 50],
		show_filter: true,
		show_pagination: true,
		pagination: "advance",
		button: {
		excel: false,
		print: false,
		},
	};

	return (
		<>
			<div className="wrapper">
				<Toaster />
				<Header />
				<Sidebar />
				<div className="content-wrapper">
					<div className="container-full">
						{/* Main content */}
						<div className="content-header">
							<div className="d-flex align-items-center">
								<div className="me-auto">
									<h3 className="page-title mb-3 mb-md-5 pb-2">Ad Counters</h3>
								</div>
							</div>
							<hr />
						</div>
						<section className="content">
							<div className="row">
								<div className="col-lg-12 col-12">
									<div className="box">
									<div className="box-header with-border">
										<div className="row mb-15 align-items-center">
											<h4 className="box-title col-12 mb-2 mb-md-0">Ad Counters ({rows.length})</h4>
										</div>
									</div>
									
									<div className="box-body">
										<div className="table-responsive" style={{ overflowX: 'auto' }}>
											<ReactDatatable
												config={configForTable}
												records={rows}
												columns={columns}
											/>
										</div>
									</div>
									</div>
								</div>
							</div>
						</section>                       
					</div>
				</div>	    
				<Footer />
			</div>
		</>
	)
}
export default AdCounterList;

